import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import FormButton from 'components/form-components/FormButton';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import SendWebPageModal from 'pages/submissions/SendWebPage/SendWebPageModal';

const TaskSubmissionsActions = ({
  ids,
  actionsCallBack,
  isActionButton,
  webPagePayloadDetails,
}) => {
  const { t } = useTranslation();

  const [actionsOptions, setActionsOptions] = useState([]);
  const [confirmModalProps, setConfirmModalProps] = useState(null);
  const [showSendWebpageModal, setShowSendWebpageModal] = useState(false);

  useEffect(() => {
    const hasPrimary = ids.some((v) => v.primary);
    const allOptions = [
      {
        value: 'make_primary',
        displayValue: 'select_make_primary',
        permission: ids.length === 1 && !hasPrimary,
      },
      { value: 'delete', displayValue: 'select_delete', permission: !hasPrimary },
      {
        value: 'send_pdf_copy',
        displayValue: 'action_send_pdf_copy',
        permission: ids.length === 1 && hasPrimary,
      },
    ];

    const visibleOptions = allOptions.filter((option) => option.permission);

    setActionsOptions(visibleOptions);
  }, [ids.length]);

  const handleAction = (_, value) => {
    if (value === 'make_primary' || value === 'delete') {
      setConfirmModalProps({
        type: value,
        title: value === 'make_primary' ? 'alert_task_primary_title' : 'alert_task_deletion_title',
        message:
          value === 'make_primary' ? 'alert_task_primary_message' : 'alert_task_deletion_message',
        text: value === 'make_primary' ? 'button_make_primary' : 'button_delete',
      });
    } else if (value === 'send_pdf_copy') {
      setShowSendWebpageModal(true);
    }
  };

  const handleConfirmAction = () => {
    if (confirmModalProps.type === 'make_primary')
      actionsCallBack(confirmModalProps.type, { id: ids[0].id });
    else if (confirmModalProps.type === 'delete')
      actionsCallBack(confirmModalProps.type, { ids: ids.map((i) => i.id) });

    setConfirmModalProps(null);
  };

  return (
    <>
      {confirmModalProps && (
        <ConfirmationModal
          show={!!confirmModalProps}
          title={t(confirmModalProps.title)}
          message={t(confirmModalProps.message)}
          actionList={[
            {
              color: 'black-1',
              text: t('button_cancel'),
              onClick: () => setConfirmModalProps(null),
            },
            {
              color: 'red-1',
              text: t(confirmModalProps.text),
              onClick: () => handleConfirmAction(),
            },
          ]}
        />
      )}
      <MultiLevelSelect
        options={{ children: actionsOptions }}
        value={[]}
        name='action'
        handleChange={(name, value) => handleAction(name, value[0])}
        toggleClasses=''
        toggleComponent={
          <>
            {isActionButton ? (
              <img className='cursor-pointer' src={dotsIcon} />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} minWidth />
            )}
          </>
        }
        disabled={!ids.length || !actionsOptions.length}
      />

      {showSendWebpageModal && (
        <SendWebPageModal
          handleClose={() => setShowSendWebpageModal(false)}
          webPagePayloadDetails={webPagePayloadDetails}
          submissionId={ids[0].id}
        />
      )}
    </>
  );
};

TaskSubmissionsActions.propTypes = {
  ids: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  isActionButton: PropTypes.bool.isRequired,
  webPagePayloadDetails: PropTypes.object,
};

export default TaskSubmissionsActions;
